// List of chess-related emojis
const CHESS_EMOJIS = [
  "♟️",
  "🎮",
  "🎯",
  "🎲",
  "🧠", // Game related
  "🏆",
  "👑",
  "⚔️",
  "🛡️", // Victory related
  "🧩",
  "🎪",
  "🎭",
  "🎨", // More game/strategy related
  "⏱️",
  "⏰",
  "⌛",
  "⏳", // Time related (chess clock)
  "🤔",
  "💭",
  "💡",
  "🧐", // Thinking related
  "🥇",
  "🥈",
  "🥉",
  "🏅", // Competition related
  "😎",
  "🤩",
  "😤",
  "🥳", // Game emotions
];

/**
 * Sets a random emoji as the website favicon
 */
export function setRandomEmojiFavicon(): void {
  // Select a random emoji from the list
  const randomEmoji =
    CHESS_EMOJIS[Math.floor(Math.random() * CHESS_EMOJIS.length)];

  // Create a canvas to draw the emoji
  const canvas = document.createElement("canvas");
  canvas.width = 32;
  canvas.height = 32;

  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  // Draw the emoji in the center of the canvas
  ctx.font = "28px serif";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(randomEmoji, 16, 16);

  // Convert canvas to data URL
  const dataUrl = canvas.toDataURL("image/png");

  // Set as favicon
  const linkElement = document.querySelector('link[rel="icon"]');
  if (linkElement) {
    linkElement.setAttribute("href", dataUrl);
  } else {
    // Create a new favicon link if one doesn't exist
    const newLink = document.createElement("link");
    newLink.rel = "icon";
    newLink.href = dataUrl;
    document.head.appendChild(newLink);
  }
}

